var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpCircleDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19710_59583)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00008 2.00002C4.68637 2.00002 2.00008 4.68631 2.00008 8.00002C2.00008 11.3137 4.68637 14 8.00008 14C11.3138 14 14.0001 11.3137 14.0001 8.00002C14.0001 4.68631 11.3138 2.00002 8.00008 2.00002ZM0.666748 8.00002C0.666748 3.94993 3.94999 0.666687 8.00008 0.666687C12.0502 0.666687 15.3334 3.94993 15.3334 8.00002C15.3334 12.0501 12.0502 15.3334 8.00008 15.3334C3.94999 15.3334 0.666748 12.0501 0.666748 8.00002Z",
    fill: "#2C303B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33325 11.3334C7.33325 10.9652 7.63173 10.6667 7.99992 10.6667H8.00659C8.37478 10.6667 8.67325 10.9652 8.67325 11.3334C8.67325 11.7015 8.37478 12 8.00659 12H7.99992C7.63173 12 7.33325 11.7015 7.33325 11.3334Z",
    fill: "#2C303B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.17199 5.34954C7.86165 5.29631 7.54247 5.35463 7.27101 5.51417C6.99954 5.67372 6.7933 5.92419 6.6888 6.22122C6.56662 6.56855 6.18601 6.75107 5.83869 6.62888C5.49136 6.5067 5.30884 6.12609 5.43103 5.77877C5.64001 5.18469 6.05249 4.68375 6.59543 4.36466C7.13836 4.04557 7.77671 3.92893 8.3974 4.0354C9.0181 4.14186 9.58108 4.46457 9.98665 4.94635C10.3921 5.42803 10.6141 6.03765 10.6132 6.66727C10.6129 7.68751 9.85654 8.36126 9.31638 8.72136C9.02596 8.91498 8.74028 9.05734 8.52984 9.15087C8.42367 9.19806 8.33427 9.23386 8.26985 9.2584C8.23758 9.27069 8.21142 9.28022 8.19238 9.28699L8.16923 9.2951L8.16185 9.29762L8.15926 9.2985L8.15823 9.29884C8.15803 9.2989 8.1574 9.29912 7.94658 8.66666L8.1574 9.29912C7.8081 9.41555 7.43056 9.22678 7.31413 8.87748C7.19777 8.52842 7.38622 8.15114 7.73507 8.03444L7.73421 8.03472C7.73428 8.0347 7.73434 8.03469 7.73507 8.03444L7.7457 8.03071C7.75596 8.02706 7.77277 8.02096 7.79519 8.01242C7.84014 7.99529 7.90699 7.9686 7.98832 7.93245C8.15288 7.85932 8.3672 7.75168 8.57678 7.61196C9.03651 7.30547 9.27991 6.97942 9.27991 6.66666L9.27992 6.66567C9.28038 6.35079 9.1694 6.0459 8.96662 5.80501C8.76383 5.56412 8.48234 5.40277 8.17199 5.34954Z",
    fill: "#2C303B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19710_59583"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCircleDark);
export default __webpack_public_path__ + "static/media/help-circle-dark.2f430fc20b75b805a1140783cdcfa8e1.svg";
export { ForwardRef as ReactComponent };